import React, {PropTypes} from 'react';
import VirtualEntryContainer from './VirtualEntryContainer.jsx';

const VirtualEntryList = ({
  source
}) => (
  <div className="list-group">
    {source.map((item, index) => (
      <VirtualEntryContainer
        key={index}
        zindexvalue={source.length + 3 - index} // Stack zIndex inversely to prevent hiding dropdowns
        {...item}
      />
    ))}
  </div>
);

VirtualEntryList.propTypes = {
  source: PropTypes.arrayOf(PropTypes.object)
};

VirtualEntryList.defaultProps = {
  source: []
};

export default VirtualEntryList;



// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/VirtualEntryList.jsx